import { zodResolver } from '@hookform/resolvers/zod';
import clsx from 'clsx';
import {
  FieldValues,
  FormProvider,
  SubmitHandler,
  useForm,
  UseFormProps,
  UseFormReturn,
} from 'react-hook-form';
import { ZodType, ZodTypeDef } from 'zod';

export type FormProps<TFormValues extends FieldValues, Schema> = {
  id?: string;
  schema?: Schema;
  options?: UseFormProps<TFormValues>;
  onSubmit: SubmitHandler<TFormValues>;
  children: (methods: UseFormReturn<TFormValues>) => React.ReactNode;
  className?: string;
};

export const Form = <
  TFormValues extends Record<string, unknown> = Record<string, unknown>,
  Schema extends ZodType<unknown, ZodTypeDef, unknown> = ZodType<unknown, ZodTypeDef, unknown>
>({
  id,
  schema,
  options,
  onSubmit,
  children,
  className,
}: FormProps<TFormValues, Schema>) => {
  const methods = useForm<TFormValues>({ ...options, resolver: schema && zodResolver(schema) });
  return (
    <FormProvider {...methods}>
      <form
        id={id}
        noValidate
        className={clsx('space-y-6', className)}
        onSubmit={methods.handleSubmit(onSubmit)}
      >
        {children(methods)}
      </form>
    </FormProvider>
  );
};
